module.exports = __webpack_public_path__ + "static/media/leather_strap_black_red_norton_v4.e2e4fe00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leather_strap_black_red_norton_v4.png
// module id = 124
// module chunks = 0